<div class="controls-container">
    <div class="controls-header">Text Box</div>

    <div class="controls-sub-header">Text Box</div>

    <pm-text-box Watermark="Watermark" [Text]="TextBoxText"></pm-text-box>

    <div class="controls-sub-header">Text Box Theme</div>
    
    <pm-text-box Watermark="Watermark" TextBoxClass="text-box-input-theme-1"></pm-text-box>

    <div class="controls-sub-header">Textarea</div>

    <pm-textarea></pm-textarea>

    <div class="controls-sub-header">Textarea Theme</div>
    
    <pm-textarea TextareaClass="textarea-input-theme" [Text]="TextareaText"></pm-textarea>

    <div class="controls-sub-header">MultiSelect Text Box</div>
    
    <pm-multi-select-text-box></pm-multi-select-text-box>

    <div class="controls-sub-header">MultiSelect Text Box Theme</div>
    
    <pm-multi-select-text-box 
        Watermark="Make a selection..."
        MultiSelectTextBoxClass="text-box-input-theme-1"
        MultiSelectTextBoxButtonClass="button-icon-flat"
        MultiSelectTextBoxSelectedItemsClass="multi-select-text-box-selected-items-theme-1"></pm-multi-select-text-box>

</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/text-box/text-box.html